import { Delegate, inView } from "vendor";
import { $4, $$4, $id4, getterAdd, getterGet, getterRunFn, _matchMedia, debounce } from "global";
var currentView = $4('[is="hdt-switch-to-list-view"].is-active') ? ":list" : ":grid",
    prevView = currentView,
    ifDiffView = !1;
const str_shopify_section = "shopify-section",
    str_layout_sw = "hdt-view-layout-switch";
function dispatchFacetRender(t) {
    this.dispatchEvent(new CustomEvent("facet:render", { bubbles: !0, detail: t }));
}
function getSectionID(t) {
    return (t = t.classList.contains("shopify-section") ? t : t.closest(".shopify-section")).id.replace(
        "shopify-section-",
        ""
    );
}
var _cachedFetch = new Map();
async function cachedFetch(t, e = "", r) {
    const i = t + e;
    if (_cachedFetch.has(i)) return Promise.resolve(new Response(new Blob([_cachedFetch.get(i)])));
    const a = await fetch(t, r);
    if (200 === a.status) {
        const t = a.headers.get("Content-Type");
        ((t && t.match(/text\//i)) || t.match(/application\/json/i)) &&
            a
                .clone()
                .text()
                .then((t) => {
                    _cachedFetch.set(i, t);
                });
    }
    return a;
}
var _is_dirty,
    _createSearchParams,
    createSearchParams_fn,
    _on_change,
    on_change_fn,
    _on_submit,
    on_submit_fn,
    _facets_form = new WeakMap();
class FacetsForm extends HTMLElement {
    #t;
    constructor() {
        super(),
            getterAdd(_is_dirty, this, !1),
            getterAdd(_createSearchParams, this),
            getterAdd(_on_change, this),
            getterAdd(_on_submit, this),
            getterAdd(_facets_form, this, $4("form", this));
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            getterGet(_facets_form, this).addEventListener(
                "change",
                getterRunFn(_on_change, this, on_change_fn).bind(this),
                { signal: this.#t.signal }
            ),
            getterGet(_facets_form, this).addEventListener(
                "submit",
                getterRunFn(_on_submit, this, on_submit_fn).bind(this),
                { signal: this.#t.signal }
            );
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
(_is_dirty = new WeakMap()),
    (_createSearchParams = new WeakSet()),
    (createSearchParams_fn = function () {
        const t = new URLSearchParams(new FormData(getterGet(_facets_form, this))),
            e = new URL(getterGet(_facets_form, this).action);
        return (
            t.forEach((t, r) => e.searchParams.append(r, t)),
            e.searchParams.delete("page"),
            ["filter.v.price.gte", "filter.v.price.lte"].forEach((t) => {
                "" === e.searchParams.get(t) && e.searchParams.delete(t);
            }),
            e.searchParams.set("section_id", this.getAttribute("section-id")),
            e
        );
    }),
    (_on_change = new WeakSet()),
    (on_change_fn = function (t) {
        getterAdd(_is_dirty, this, !0, !0),
            this.hasAttribute("render-on-change") && !t.target?.hasAttribute("disable-change")
                ? HTMLFormElement.prototype.requestSubmit
                ? getterGet(_facets_form, this).requestSubmit()
                : getterGet(_facets_form, this).dispatchEvent(new Event("submit", { cancelable: !0 }))
                : 
                console.log(t.target, 't.target');
                 var filterCount = t.target.closest(".hdt-filter-group__list").querySelectorAll(".hdt-filter-group__list-item > input:checked").length;
                 var categoryItem = t.target.closest(".hdt-filter-options-content");
                 var clearFilter = document.querySelector('.hdt-filter-footer-clear');
                if (!categoryItem) return;
                var index  = categoryItem.dataset.filterIndex;
                var handle = categoryItem.dataset.filterHandle;
                var filterCategorySelector = `.hdt-filter-category-item[data-filter-index="${index}"][data-filter-handle="${handle}"]`;
                var filterCategory = document.querySelector(filterCategorySelector);
                var filterCategoryCount = filterCategory.querySelector(".hdt-filter-category-count");
                var el = document.createElement("span");
                el.className = "hdt-filter-category-count";
                el.textContent = filterCount;
                console.log("checked siblings count:",  filterCount);
                filterCategoryCount ? filterCategoryCount.innerHTML = filterCount : filterCategory.appendChild(el);
                if (filterCount > 0) clearFilter.classList.add('active-clear-btn');
                if (document.querySelector(".hdt-facet-filters-form-mobile").classList.contains("clearing-filter")) return;
                fetch(getterRunFn(_createSearchParams, this, createSearchParams_fn).call(this).toString())
                    .then(function(res) { return res.text(); })
                    .then(function(htmlString) {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(htmlString, "text/html");
                
                        var fetchedFacets = doc.querySelectorAll(".hdt-filter-footer-submit");
                        if (!fetchedFacets.length) return;
                
                        var localFacets = document.querySelectorAll(".hdt-filter-footer-submit");
                        if (!localFacets.length) return;
                
                        localFacets.forEach(function(facet, i) {
                            if (fetchedFacets[i]) {
                                facet.innerHTML = fetchedFacets[i].innerHTML;
                            }
                        });
                    }),
                
                    cachedFetch(getterRunFn(_createSearchParams, this, createSearchParams_fn).call(this).toString(),
                      currentView)
                
    }),
    (_on_submit = new WeakSet()),
    (on_submit_fn = function (t) {
        t.preventDefault(),
            getterGet(_is_dirty, this) &&
                (dispatchFacetRender.call(getterGet(_facets_form, this), {
                    url: getterRunFn(_createSearchParams, this, createSearchParams_fn).call(this),
                }),
                getterAdd(_is_dirty, this, !1, !0));
    }),
    customElements.define("hdt-facet-filters-form", FacetsForm);
class PopoverSorting extends HTMLElement {
    #t;
    constructor() {
        super();
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            $4("hdt-popover", this).addEventListener(
                "richlist:change",
                (t) => {
                    const e = new URL(window.location.href);
                    e.searchParams.set("sort_by", t.detail.value),
                        e.searchParams.delete("page"),
                        e.searchParams.set("section_id", this.getAttribute("section-id")),
                        dispatchFacetRender.call(this, { url: e });
                },
                { signal: this.#t.signal }
            );
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
customElements.define("hdt-popover-sorting", PopoverSorting);
var _facet_click_url,
    facet_click_url_fn,
    _facet_a = new WeakMap();
class FacetUrl extends HTMLElement {
    #t;
    constructor() {
        super(), getterAdd(_facet_click_url, this), getterAdd(_facet_a, this, $4("a", this));
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            getterGet(_facet_a, this).addEventListener(
                "click",
                getterRunFn(_facet_click_url, this, facet_click_url_fn).bind(this),
                { signal: this.#t.signal }
            );
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
(_facet_click_url = new WeakSet()),
    (facet_click_url_fn = function (t) {
        t.preventDefault();
        const e = getSectionID(t.target),
            r = new URL(getterGet(_facet_a, this).href);
        r.searchParams.set("section_id", e), dispatchFacetRender.call(this, { url: r });
    }),
    customElements.define("wrapp-hdt-facet-url", FacetUrl);
var _load_more_url,
    load_more_url_fn,
    _lm_observe,
    lm_observe_fn,
    _lm_render,
    lm_render_fn,
    _lm_a = new WeakMap();
class LoadMore extends HTMLElement {
    #t;
    constructor() {
        super(),
            getterAdd(_load_more_url, this),
            getterAdd(_lm_observe, this),
            getterAdd(_lm_render, this),
            getterAdd(_lm_a, this, $4("a", this));
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            (this.abortController2 = null),
            getterGet(_lm_a, this).addEventListener(
                "click",
                getterRunFn(_load_more_url, this, load_more_url_fn).bind(this),
                { signal: this.#t.signal }
            ),
            this.isInfinite && inView(getterGet(_lm_a, this), getterRunFn(_lm_observe, this, lm_observe_fn).bind(this));
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    get isInfinite() {
        return this.hasAttribute("render-on-scroll");
    }
    get idcontrol() {
        return "#" + this.getAttribute("append");
    }
    get action() {
        return this.hasAttribute("prepend") ? "prepend" : "append";
    }
}
(_load_more_url = new WeakSet()),
    (load_more_url_fn = function (t) {
        t.preventDefault();
        const e = new URL(getterGet(_lm_a, this).href);
        e.searchParams.set("section_id", this.getAttribute("section-id")),
            getterRunFn(_lm_render, this, lm_render_fn).call(this, {
                detail: { url: e, id: this.idcontrol, action: this.action },
            });
    }),
    (_lm_observe = new WeakSet()),
    (lm_observe_fn = function (t) {
        t.isIntersecting && t.target.click();
    }),
    (_lm_render = new WeakSet()),
    (lm_render_fn = async function (t) {
        this.abortController2 && this.abortController2.abort(), (this.abortController2 = new AbortController());
        const e = t.detail.url,
            r = e.searchParams.get("section_id"),
            i = e.searchParams.get("page"),
            a = document.getElementById(`shopify-section-${r}`);
        new URL(e).searchParams.delete("section_id");
        const n = $4(t.detail.id, a),
            s = $4("[loadmore-btn-wrapp]", a);
        try {
            s.setAttribute("loading", "");
            const r = new DOMParser().parseFromString(
                    await (
                        await cachedFetch(e.toString(), currentView, { signal: this.abortController2.signal })
                    ).text(),
                    "text/html"
                ),
                a = $4(`.shopify-section ${t.detail.id}`, r),
                o = "append" == t.detail.action;
            n[o ? "lastElementChild" : "firstElementChild"].classList.add(`point-effect-${i}`),
                n[t.detail.action](...document.importNode(a, !0).childNodes),
                n.dispatchEvent(new CustomEvent("products:update", { bubbles: !0 })),
                _matchMedia("motion") &&
                    ((n.prependEl = o ? `.point-effect-${i} ~ ` : ""),
                    (n.appendEl = o ? "" : `:not(nathan ~ .point-effect-${i}):not(.point-effect-${i} ~ nathan)`),
                    n.reveal && n.reveal());
            const c = $4("[loadmore-btn-wrapp]", r);
            c
                ? (s.replaceChildren(...document.importNode(c, !0).childNodes), s.removeAttribute("loading"))
                : s.remove();
        } catch (t) {}
    }),
    customElements.define("wrapp-hdt-lm-main-url", LoadMore);
class PriceRange extends HTMLElement {
    #t;
    constructor() {
        super(),
            (this.rangePriceInputs = $$4(".hdt-filter-group__range-price input", this)),
            (this.inputPriceInputs = $$4(".hdt-filter-group__input-price input", this)),
            (this.priceGap = 0);
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            this.rangePriceInputs.forEach((t) =>
                t.addEventListener("input", this.onRangeInput.bind(this), { signal: this.#t.signal })
            ),
            this.inputPriceInputs.forEach((t) => {
                t.addEventListener("input", debounce(this.onPriceInput.bind(this), 350, { signal: this.#t.signal })),
                    t.addEventListener("change", this.onPriceChange.bind(this), { signal: this.#t.signal });
            });
    }
    disconnectedCallback() {
        this.#t.abort();
    }
    onRangeInput(t) {
        const e = this.inputPriceInputs[0],
            r = this.inputPriceInputs[1],
            i = this.rangePriceInputs[0],
            a = this.rangePriceInputs[1];
        let n = Number(i.value),
            s = Number(a.value);
        s - n < this.priceGap
            ? t.target === i
                ? (i.value = s - this.priceGap)
                : (a.value = n + this.priceGap)
            : ((e.value = n),
              (r.value = s),
              this.style.setProperty("--min-progress", (n / i.max) * 100 + "%"),
              this.style.setProperty("--max-progress", 100 - (s / a.max) * 100 + "%"));
    }
    onPriceInput(t) {
        const e = this.inputPriceInputs[0],
            r = this.inputPriceInputs[1],
            i = this.rangePriceInputs[0],
            a = this.rangePriceInputs[1];
        let n = Number(e.value),
            s = Number(r.value);
        "filter.v.price.gte" === t.target.name
            ? ((i.value = Math.max(n, t.target.min)),
              this.style.setProperty("--min-progress", (i.value / i.max) * 100 + "%"))
            : ((a.value = Math.min(s, t.target.max)),
              this.style.setProperty("--max-progress", 100 - (a.value / a.max) * 100 + "%"));
    }
    onPriceChange(t) {
        t.preventDefault();
        const e = "filter.v.price.gte" === t.target.name ? 0 : 1;
        (t.target.value = e
            ? Math.min(
                  Math.max(parseInt(t.target.value), parseInt(this.inputPriceInputs[0].value || t.target.min) + 1),
                  t.target.max
              )
            : Math.max(
                  Math.min(parseInt(t.target.value), parseInt(this.inputPriceInputs[1].value || t.target.max) - 1),
                  t.target.min
              )),
            (this.rangePriceInputs[e].value = t.target.value),
            this.rangePriceInputs[e].dispatchEvent(new Event("input", { cancelable: !0 }));
    }
}
class SubmitButtonFilter extends HTMLElement {
    #t;
    constructor() {
        super();
    }
    connectedCallback() {
        (this.#t = new AbortController()),
            this.addEventListener(
                "click",
                (t) => {
                    t.preventDefault(), t.stopPropagation();
                    const e = this.closest("form");
                    HTMLFormElement.prototype.requestSubmit
                        ? e?.requestSubmit()
                        : e?.dispatchEvent(new Event("submit", { bubbles: !0, cancelable: !0 }));
                },
                { signal: this.#t.signal }
            );
    }
    disconnectedCallback() {
        this.#t.abort();
    }
}
customElements.define("hdt-price-range", PriceRange),
    customElements.define("wrapp-hdt-btn-submit-filter", SubmitButtonFilter);
var _delegate,
    _layout_switch,
    layout_switch_fn,
    _breakpoint,
    _layout_prefix,
    _update_attributes,
    update_attributes_fn,
    _layout_changed,
    layout_changed_fn,
    currentSwitchSizes,
    switch_to_list_view_fn,
    objPrefix = { mobile: "", tablet: "md:", desktop: "lg:" },
    objIndex = { mobile: 0, tablet: 1, desktop: 2 },
    viewsLayout = $4(str_layout_sw) ? $4(str_layout_sw).getAttribute("views") : "",
    _switch_to_list_view = new WeakSet();
class LayoutSwitch extends HTMLElement {
    constructor() {
        super(),
            getterAdd(_delegate, this, new Delegate(this)),
            getterAdd(_layout_switch, this),
            getterAdd(_breakpoint, this, this.getAttribute("breakpoint")),
            getterAdd(_layout_prefix, this, objPrefix[getterGet(_breakpoint, this)] + "hdt-grid-cols-"),
            getterAdd(_update_attributes, this),
            getterAdd(_layout_changed, this),
            getterAdd(_switch_to_list_view, this);
    }
    static get observedAttributes() {
        return ["views"];
    }
    attributeChangedCallback(t, e, r) {
        getterRunFn(_layout_changed, this, layout_changed_fn).call(this, t, e, r);
    }
    connectedCallback() {
        getterGet(_delegate, this).on(
            "click",
            'button[type="button"]',
            getterRunFn(_layout_switch, this, layout_switch_fn).bind(this)
        ),
            getterGet(_delegate, this).on(
                "update:products_items_per_row",
                getterRunFn(_switch_to_list_view, this, switch_to_list_view_fn).bind(this)
            );
    }
    disconnectedCallback() {
        getterGet(_delegate, this).off();
    }
    get $control() {
        return $id4(this.getAttribute("aria-controls"));
    }
}
(_breakpoint = new WeakMap()),
    (_layout_prefix = new WeakMap()),
    (_delegate = new WeakMap()),
    (_layout_switch = new WeakSet()),
    (layout_switch_fn = function (t, e) {
        if (e.classList.contains("is-active")) return;
        const r = this.getAttribute("views").split(".");
        r.indexOf("0") > -1 && 0 != e.value
            ? r.forEach((t, e) => {
                  0 == t && (r[e] = e + 2);
              })
            : 0 == e.value && r.forEach((t, e) => (r[e] = 0)),
            (currentSwitchSizes = e.getAttribute("sizes")),
            (r[objIndex[getterGet(_breakpoint, this)]] = e.value),
            getterRunFn(_update_attributes, this, update_attributes_fn).call(this, r.join("."), e.hasAttribute("is"));
    }),
    (_update_attributes = new WeakSet()),
    (update_attributes_fn = function (t, e) {
        (ifDiffView = prevView != (currentView = e ? ":list" : ":grid")),
            (prevView = currentView),
            (viewsLayout = t),
            $$4(str_layout_sw).forEach((e) => e.setAttribute("views", t));
        const r = new URL(themeHDN.wisHref ? window.location.origin + themeHDN.wisHref : window.location.href);
        r.searchParams.delete("page"), r.searchParams.set("section_id", this.getAttribute("section-id"));
        var i = !0;
        ifDiffView & _cachedFetch.has(r.toString() + currentView) &&
            ((i = !1), dispatchFacetRender.call(this, { url: r, disableScrollToVIew: !0 })),
            ifDiffView &&
                i &&
                (this.closest(".shopify-section").setAttribute("loading", ""),
                document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: !0 }))),
            fetch(`${Shopify.routes.root}cart/update.js`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ attributes: { products_items_per_row: t } }),
                keepalive: !0,
            }).then((t) => {
                200 === t.status && ifDiffView && i
                    ? this.dispatchEvent(new CustomEvent("update:products_items_per_row"), { bubbles: !0 })
                    : ifDiffView &&
                      i &&
                      (this.closest(".shopify-section").removeAttribute("loading"),
                      document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 })));
            });
    }),
    (_layout_changed = new WeakSet()),
    (layout_changed_fn = function (t, e, r) {
        if (null !== e && r !== e) {
            const t = e.split("."),
                i = r.split("."),
                a = t[objIndex[getterGet(_breakpoint, this)]],
                n = i[objIndex[getterGet(_breakpoint, this)]];
            if (($$4("button", this).forEach((t) => t.classList.toggle("is-active", t.value == n)), ifDiffView)) return;
            _matchMedia("motion") &&
                (clearTimeout(this.$control.timeout),
                (this.$control.timeout = setTimeout(() => {
                    this.$control.classList.remove(getterGet(_layout_prefix, this) + a),
                        this.$control.classList.add(getterGet(_layout_prefix, this) + n),
                        $$4(".hdt-card-product__media img", this.$control).forEach((t) =>
                            t.setAttribute("sizes", $4(".is-active", this).getAttribute("sizes"))
                        ),
                        this.$control.reveal();
                })));
        }
    }),
    (switch_to_list_view_fn = function (t) {
        const e = new URL(themeHDN.wisHref ? window.location.origin + themeHDN.wisHref : window.location.href);
        e.searchParams.delete("page"),
            e.searchParams.set("section_id", this.getAttribute("section-id")),
            dispatchFacetRender.call(this, { url: e, disableScrollToVIew: !0 });
    }),
    customElements.define(str_layout_sw, LayoutSwitch),
    (() => {
        window.addEventListener("popstate", (t) => {
            if (t.state && t.state.FacetUrl) {
                const e = new URL(t.state.FacetUrl);
                e.searchParams.set("section_id", t.state.section_id),
                    dispatchFacetRender.call(document, { url: e, notPushState: !0 });
            }
        });
        var t = null,
            e = new Delegate(document.body),
            r = new Set(Array.from($$4('hdt-facet-filters-form details[open] input[name*="filter."]'), (t) => t.name));
        e.on(
            "toggle",
            "hdt-facet-filters-form details",
            (t, e) => {
                [...new Set(Array.from($$4('input[name*="filter."]', e), (t) => t.name))].forEach((t) => {
                    e.open ? r.add(t) : r.delete(t);
                });
            },
            !0
        ),
            document.addEventListener("facet:render", async (e) => {
                t && t.abort(), (t = new AbortController());
                const i = e.detail.url,
                    a = i.searchParams.get("section_id"),
                    n = $id4(`shopify-section-${a}`),
                    s = new URL(i);
                s.searchParams.delete("section_id");
                const o = $4("[main-content]", n);
                try {
                    n.setAttribute("loading", ""),
                        document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: !0 }));
                    const c = new DOMParser().parseFromString(
                        await (await cachedFetch(i.toString(), currentView, { signal: t.signal })).text(),
                        "text/html"
                    );
                    document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 }));
                    const l = $4(".shopify-section [main-content]", c);
                    if (
                        ($$4("hdt-facet-filters-form details", l).forEach((t) => {
                            [...new Set(Array.from($$4('input[name*="filter."]', t), (t) => t.name))].forEach((e) => {
                                t.open = r.has(e);
                            });
                        }),
                        e.detail.notPushState ||
                            history.pushState({ FacetUrl: s.toString(), section_id: a }, "", s.toString()),
                        $4(str_layout_sw, l))
                    ) {
                        const t = $4(str_layout_sw, l).getAttribute("views");
                        if (t !== viewsLayout) {
                            const e = t.split("."),
                                r = ["", "md:", "lg:"],
                                i = $4(`#products-${a}`, l);
                            let n = i.className;
                            const s = viewsLayout.split(".");
                            $$4(str_layout_sw, l).forEach((t, i) => {
                                t.setAttribute("views", viewsLayout),
                                    $4(".is-active", t).classList.remove("is-active"),
                                    $4(`button[value="${s[i]}"]`, t).classList.add("is-active"),
                                    (n = n.replace(` ${r[i]}hdt-grid-cols-${e[i]}`, ` ${r[i]}hdt-grid-cols-${s[i]}`));
                            }),
                                (i.className = n),
                                $$4(".hdt-card-product__media img", i).forEach((t) =>
                                    t.setAttribute("sizes", currentSwitchSizes)
                                );
                        }
                    }
                    o.replaceChildren(...document.importNode(l, !0).childNodes),
                        o.dispatchEvent(new CustomEvent("products:update", { bubbles: !0 })),
                        $$4(".hdt-tooltip").forEach((t) => t.remove()),
                        n.removeAttribute("loading", "");
                    // const h = $4("[scroll-into-view]", n);
                    // if (!h || e.detail.disableScrollToVIew) return;
                    // const d = () => h.scrollIntoView({ block: "start", behavior: "smooth" });
                    // "requestIdleCallback" in window
                    //     ? requestIdleCallback(d, { timeout: 500 })
                    //     : requestAnimationFrame(d);
                } catch (t) {}
            });
    })();

    document.addEventListener("click", e => {
        const item = e.target.closest(".hdt-filter-category-item");
        if (!item) return;
      
        const index  = item.dataset.filterIndex;
        const handle = item.dataset.filterHandle;
      
        // Category active state
        item.parentElement
            .querySelectorAll(".hdt-filter-category-item")
            .forEach(el => el.classList.toggle("hdt-filter-category-active", el === item));
      
        // Options active state
        const contentSelector = `.hdt-filter-options-content[data-filter-index="${index}"][data-filter-handle="${handle}"]`;
        const content = document.querySelector(contentSelector);
      
        content.parentElement
            .querySelectorAll(".hdt-filter-options-content")
            .forEach(el => el.classList.toggle("hdt-filter-options-active", el === content));
      });

      window.applyFilter = function(t) {
        console.log(t.target, 't.target');
        var filterCount = t.target.closest(".hdt-filter-group__list").querySelectorAll(".hdt-filter-group__list-item > input:checked").length;
        var categoryItem = t.target.closest(".hdt-filter-options-content");
       if (!categoryItem) return;
       var index  = categoryItem.dataset.filterIndex;
       var handle = categoryItem.dataset.filterHandle;
       var filterCategorySelector = `.hdt-filter-category-item[data-filter-index="${index}"][data-filter-handle="${handle}"]`;
       var filterCategory = document.querySelector(filterCategorySelector);
       var filterCategoryCount = filterCategory.querySelector(".hdt-filter-category-count");
       var el = document.createElement("span");
       el.className = "hdt-filter-category-count";
       el.textContent = filterCount;
       console.log("checked siblings count:",  filterCount);
       filterCategoryCount ? filterCategoryCount.innerHTML = filterCount : filterCategory.appendChild(el),

       fetch(getterRunFn(_createSearchParams, this, createSearchParams_fn).call(this).toString())
           .then(function(res) { return res.text(); })
           .then(function(htmlString) {
               var parser = new DOMParser();
               var doc = parser.parseFromString(htmlString, "text/html");
       
               var fetchedFacets = doc.querySelectorAll(".hdt-filter-footer-submit");
               if (!fetchedFacets.length) return;
       
               var localFacets = document.querySelectorAll(".hdt-filter-footer-submit");
               if (!localFacets.length) return;
       
               localFacets.forEach(function(facet, i) {
                   if (fetchedFacets[i]) {
                       facet.innerHTML = fetchedFacets[i].innerHTML;
                   }
               });
           })
      }

      Shopify.filterSticky = function () {
        const header = document.querySelector('.shopify-section-header-sticky');
        const filterPlp = document.querySelector('.hdt-control-filter');
        const sentinel = document.querySelector('.filter-sticky-sentinel');
        const cartNotification = document.querySelector('.cart-notification-wrapper');
        const filterHeight = filterPlp.offsetHeight;
        if (!header || !filterPlp || !sentinel || window.innerWidth >= 1023) return;
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          const accordion = filterPlp.querySelector("hdt-accordion.hdt-contents");
      
          if (!entry.isIntersecting) {
            // Set placeholder height to prevent layout shift
            sentinel.style.height = `${filterHeight}px`;
            filterPlp.classList.add('sticky_collection_filter');
            requestAnimationFrame(() => filterPlp.classList.add('show'));
      
            cartNotification?.classList.add('collection-cart-notification');
            accordion?.classList.add("sticky-skin-type");
            accordion?.classList.remove("skin-type");
      
          } else {
            
            filterPlp.classList.remove('show');
            setTimeout(() => {
              filterPlp.classList.remove('sticky_collection_filter');
              sentinel.style.height = `1px`;
            }, 300);
      
            cartNotification?.classList.remove('collection-cart-notification');
            accordion?.classList.remove("sticky-skin-type");
            accordion?.classList.add("skin-type");
          }
        }, {
          threshold: 0
        });
      
        observer.observe(sentinel);
      };

      // Initial run
  Shopify.filterSticky();
  
  // === Auto re-run when DOM changes (in case the header/filter loads later) ===
  const collectionTargetNode = document.querySelector('.hdt-main-section__collection');

if (collectionTargetNode) {
  const domObserver = new MutationObserver(() => {
    Shopify.filterSticky(); // Re-run setup if new elements are added

    document.querySelectorAll(".hdt-filter-plp .hdt-filter-group__list .hdt-filter-group__list-item input")
    .forEach(input => {
      input.addEventListener("change", function () {
        let category = input.dataset.category;
        let value = input.dataset.lable;
        let checkFlag = input.checked;
        setTimeout(function () {
          const collectionContainer = document.querySelector(".hdt-collection-container");
          if (!collectionContainer) return;

          const offset = 136;
          const topPos = collectionContainer.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({
            top: topPos,
            behavior: "smooth"
          });
          if(checkFlag){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': `${category}-selected`,
                'value': value
            });
          }


        }, 1000); // Delay, if needed for filters to update content
      });
    });

  });

  domObserver.observe(collectionTargetNode, {
    childList: true,
    subtree: true
  });
}

document.addEventListener("click", function (e) {
    var clearBtn = e.target.closest(".hdt-mobile-filter_drawer .hdt-filter-footer-clear.active-clear-btn");
    if (!clearBtn) return;

    e.preventDefault();
    document.querySelector(".hdt-facet-filters-form-mobile").classList.add("clearing-filter");

    /* 1. Uncheck all filter checkboxes */
    var checkboxes = document.querySelectorAll(
        ".hdt-mobile-filter_drawer .hdt-filter-group__list-item input[type='checkbox']"
    );

    checkboxes.forEach(function (checkbox) {
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    });

    /* 2. Reset category counts */
    document.querySelectorAll(".hdt-filter-category-count").forEach(function (count) {
        count.textContent = "0";
    });

    /* 3. Update footer submit text (via fetch) */
    var mobileFacetForm = document.querySelector(".hdt-facet-filters-form-mobile"); // facets form
    if (!mobileFacetForm) return;

    var mobileFilterUrl = getterRunFn(_createSearchParams, mobileFacetForm, createSearchParams_fn).call(mobileFacetForm).toString();

    fetch(mobileFilterUrl)
    .then(function(res) { return res.text(); })
    .then(function(htmlString) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(htmlString, "text/html");

        var fetchedFacets = doc.querySelectorAll(".hdt-filter-footer-submit");
        if (!fetchedFacets.length) return;

        var localFacets = document.querySelectorAll(".hdt-filter-footer-submit");
        if (!localFacets.length) return;

        localFacets.forEach(function(facet, i) {
            if (fetchedFacets[i]) {
                    facet.innerHTML = fetchedFacets[i].innerHTML;    
            }
        });
    }),

    /* 4. Disable clear button */
    clearBtn.classList.remove("active-clear-btn");
    document.querySelector(".hdt-facet-filters-form-mobile").classList.remove("clearing-filter");
});
